module.exports = __webpack_public_path__ + "img/user-hui.c65109de.svg";